<template>
  <div class="direct-document">
    <div class="bold tac mb-20">{{ direct.organization__name }}</div>
    <table class="mb-20">
      <tr>
        <td>
          <div class="bold tac mb-10">{{ direct.register_book__name }}-НАЗОРАТ КАРТОЧКАСИ</div>
          <div class="level">
            <div class="level-left">Kartochka raqami: ________</div>
            <div class="level-right">
              Ro’yxatga olish sanasi: {{ direct.registered_date }}<br>
              Ro’yxatdat o’tqazish raqami №{{ direct.registration_number }}
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div><span class="bold">HUJJATNING NOMI:</span> {{ direct.type__name }}</div>
          <div>{{ direct.description }}</div>
        </td>
      </tr>
      <tr>
        <td>{{ direct.registered_date }} dagi {{ direct.registration_number }}-сонли</td>
      </tr>
      <tr>
        <td>
          <div class="bold">NAZORAT BANDLARI:</div>
          <div v-for="plan_group in direct.plan_groups">
            {{ plan_group.order_number }}.{{ plan_group.name }}
            <div v-for="plan_item in plan_group.plan_items">
              {{ plan_group.order_number }}.{{ plan_item.order_number }} {{ plan_item.name }}
            </div>
          </div>
          <div v-for="plan_item in direct.plan_items">
            {{ plan_item.order_number }} {{ plan_item.name }}
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>Rahbar ko’rsatmasi:</div>
          <div class="sign-placeholder"></div>
          <div class="sign-placeholder"></div>
          <div class="level mt-10">
            <div class="level-left">
              <div class="bold">
                {{ direct.approver__post_name }}<br>
                {{ direct.approver__initials }}
              </div>
            </div>
            <div class="level-right">
              ________________________<br>
              (imzo)
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>Ma’sul ijrochi:</div>
          <div class="bold">
            {{ direct.maintainer__initials }}<br>
            {{ direct.maintainer__post_name }}<br>
            Muddat: {{ direct.term_date }}
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Hujjatlarni berish:
          <table class="mt-5">
            <tr class="tac">
              <td>Hujjatni olgan shaxsning FISh</td>
              <td>Imzo</td>
              <td>Sana</td>
              <td>Vaqti</td>
            </tr>
            <tr v-for="(c, n) in direct.correspondents">
              <td>{{n+1}}. {{ c.name }}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <table>
      <tr>
        <td>
          <div class="tac bold mb-20">Ijro holati</div>
          <div class="big-space">
            Nazorat bandlari bo’yicha:<br>
            <span class="bold">{{ direct.close_report }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>Ijro holati qachon, qayerda muhokama etildi, kimga nisbatan qanday tashkiliy va intizomiy choralar
            ko’rildi:
          </div>
          <div v-for="n in 4" class="mt-30">{{n}}.</div>
          <div class="mt-30">Nazorat guruhining ma’sul shaxsi (ma’sul xodimi)</div>
          <div class="columns mt-30 mb-50">
            <div class="column is-4 bold">{{direct.who_close_name}}</div>
            <div class="column is-4 tac">________________<br>(imzo)</div>
            <div class="column is-4 bold">{{direct.close_date}}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="mb-30">Bajarilgan hujjatlar tikilgan yig’majild raqami,ma’sul:</div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState('Docflow', ['direct'])
    }
  }
</script>

<style lang="scss" scoped>
  .direct-document {
    font-size: 16px;
    line-height: 28px;

    h1 {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 30px;

      .sub {
        font-size: 16px;
      }
    }

    table {
      width: 100%;
      margin-bottom: 20px;
      border: 1px solid #000;
      line-height: 120%;

      tr {
        td {
          padding: 10px 16px;
          border: 1px solid #000;
        }
      }
    }

    .bold {
      font-weight: bold;
    }

    .tac {
      text-align: center;
    }

    .underline {
      text-decoration: underline;
    }

    ul {
      list-style: disc;

      li {
        margin-left: 18px;
      }
    }

    .big-space {
      margin-bottom: 180px;
    }

    .sign-placeholder {
      border-bottom: 1px solid #000;
      margin-top: 25px;
    }
  }
</style>
